import { render } from "./SchemaValidationResult.vue?vue&type=template&id=5df5234c"
import script from "./SchemaValidationResult.vue?vue&type=script&lang=js"
export * from "./SchemaValidationResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__